import { useT } from "../i18n";
import StatusBadge from "./StatusBadge";

export default function AvailabilitySection({ pro, staleDays, onStatus }) {
  const { t } = useT();
  return (
    <section className="bg-white rounded-xl border border-black/5 p-6" data-testid="availability-section">
      <h2 className="text-lg font-bold text-[#1F2937] flex items-center gap-3" style={{ fontFamily: "Manrope" }}>
        {t("pro.status.title")} <StatusBadge status={pro.status} testid="pro-current-status" />
      </h2>
      <p className="text-sm text-[#6B7280] mt-1">{t("pro.status.hint", { n: staleDays })}</p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-5">
        {["disponible", "liste_attente", "complet"].map((s) => (
          <button key={s} data-testid={`availability-btn-${s}`} onClick={() => onStatus(s)}
            className={`min-h-[56px] rounded-xl font-semibold text-sm border-2 transition-colors duration-200 ${
              pro.raw_status === s
                ? "bg-[#0D4045] text-[#FDFBF7] border-[#0D4045]"
                : "bg-white text-[#1F2937] border-[#0D4045]/15 hover:border-[#0D4045]/50"
            }`}>
            {t(`status.${s}`)}
          </button>
        ))}
      </div>
    </section>
  );
}
